import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { Modal, Form, Input, Row, Col, Checkbox, Select, message, Spin, Empty, Skeleton, DatePicker } from 'antd';
import PropTypes from 'prop-types';
import UpdateConnectionPopup from './UpdateConnectionPopup';
import DeleteConnectionPopup from './DeleteConnectionPopup';
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { getAllCustomFieldByCompanyAndEntity, findAllCustomOptionsByDropdown } from '../../../Api/Services/CustomeUIApiService';
import { convertCurrency } from '../Filters/FilterConditions';
import { getAllUsersData, getCountryData, getStateData, getCityData } from '../../../Api/Services/CommonApiService'
import { FetchAllAccount, massUpdateAccount, massDeleteAccount } from '../../../Api/Services/AccountApiService'
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { ChangeOwnerIcon, SaveIcon, CancelIcon, DeleteIcon } from '../../../components/Icons/Icons';
import { nameOnChangeValidator,validateZipCode, validateUrlField, validateDescriptionField } from '../../../components/utilities/utilities';

const { Option } = Select;

export function validateNumberField(value) {
    if (value === undefined || value === null || value === '') return null;
    const allowedRegex = /^[0-9]*$/;
    if (!allowedRegex.test(value)) return 'Only numbers are allowed';
    return null;
}

export function validateCurrencyField(value, decimalPlace = 2) {
    if (value === undefined || value === null || value === '') return null;
    const basicNumberCheck = /^\d+(\.\d*)?$/;
    if (!basicNumberCheck.test(value)) return 'Please enter a valid number';
    if (value.endsWith('.')) return null;
    const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${decimalPlace}})?$`);
    if (!decimalRegex.test(value)) return `Only up to ${decimalPlace} decimal place${decimalPlace > 1 ? 's' : ''} are allowed`;
    return null;
}

export function validatePercentageField(value, decimalPlace = 2) {
    if (value === undefined || value === null || value === '') return null;
    const basicNumberCheck = /^\d+(\.\d*)?$/;
    if (!basicNumberCheck.test(value)) return 'Please enter a valid number';
    if (value.endsWith('.')) return null;
    const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${decimalPlace}})?$`);
    if (!decimalRegex.test(value)) return `Only up to ${decimalPlace} decimal place${decimalPlace > 1 ? 's' : ''} are allowed`;
    const num = Number(value);
    if (num < 0 || num > 100) return 'Percentage must be between 0 and 100';
    return null;
}

const Popup = ({ updatePopup, setUpdatePopup, accountIDs, GetAll, popupType, action, assignOwner, pageType, setStates, successMessage }) => {
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const dispatch = useDispatch();
    const history = useHistory();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [form] = Form.useForm();
    const [accountData, setAccountData] = useState([])
    const [users, setUsers] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [companyId, setCompanyId] = useState()
    const [field3, setField3] = useState()
    const [errorData, setErrorData] = useState([])
    const [editAttributes, setEditAttributes] = useState([])
    const [allCountry, setAllCountry] = useState([])
    const [stateData, setStateData] = useState([])
    const [cityData, setCityData] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [uiReady, setUiReady] = useState(false)
    const [selectBoxes, setSelectBoxes] = useState();
    const localData = useSelector((state) => state.localRedux);
    const ENTITY_ID = localData?.allEntity?.find((item) => item.entityKey === 'accounts')?.customEntityId
    const ProfileData = localData.profile
    const profile = ProfileData
    const defaultCurrency = localData.currency
    const ConvertRate = defaultCurrency?.exchangeRate;
    const [dropdownOptions, setDropdownOptions] = useState({});
    const [dropdownLoading, setDropdownLoading] = useState({});
    const DEFAULT_DROPDOWN_FIELDS = ["accountOwner", "parentOrganization", "country", "state", "city"];
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    function RequiredValidity(queryData) {
        for (let i = 0; i < queryData.length; i += 1) {
            const query = queryData[i];
            if (!query.editedField) {
                return { isValid: false, message: 'Incomplete query' };
            }
            if (query.visible !== "No") {
                if (
                    query.editedValue === undefined ||
                    query.editedValue === null ||
                    query.editedValue === ""
                ) {
                    return { isValid: false, message: 'Incomplete query' };
                }
            }
        }
        return { isValid: true };
    }
    const handleClose = () => {
        setUpdatePopup(false);
        if (pageType === "Listing") {
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        }
        if (popupType !== "Delete") {
            // setStates({ selectedRowKeys: [] })
        }
    }
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            const options = data.filter((item) => item.account_type_name === "Customer").map((option, i) => (
                <Option value={option.account_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                    < img src={option.account_profile} alt="profile" />
                                    :
                                    <span className="image_icon AccountIcon">
                                        {option.account_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{option.account_name}</span>
                            </div>
                        </div>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                        <div>
                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.account_name.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                            <p style={{ margin: 0 }}>{option.account_number}</p>
                        </div>
                    </div>
                </Option>));
            setAccountData(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            setUsers(data)
        } catch (error) {
            message.error(error)
        }
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            const options = response.map((option) => (
                <Option key={option.countryId} value={option.country}>
                    {option.country}
                </Option>))
            setAllCountry(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const onSubmit = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        const formData = {
            accountIds: accountIDs,
            companyId,
        }
        if (popupType === "Change Owner") {
            formData.accountOwner = field3;
            const isAnyFieldUndefined = Object.values(formData).some(value => value === undefined);
            if (!isAnyFieldUndefined) {
                try {
                    const response = await massUpdateAccount(formData)
                    if (response.status === 200) {
                        if (action === "SingleChangeOwner") {
                            if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                                setErrorData(response.data);
                                setIsModalVisible1(true);
                                loadingRef.current = false;
                                setDelteClick(false)
                                dispatch(setEditCall(false))
                            }
                            else {
                                const isAutomation = response.data[0].message === AutomationMessage;
                                const isApproval = response.data[0].message === ApprovalMessage;
                                dispatch(setEditCall(false))
                                loadingRef.current = false;
                                setDelteClick(false)
                                if (isApproval) {
                                    successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                                } else if (isAutomation) {
                                    successMessage("Automation rule triggered", response.data[0].message);
                                } else {
                                    message.success(
                                        <span>
                                            Account <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                        </span>
                                    );
                                }
                                setUpdatePopup(false);
                                if (!isApproval && assignOwner !== field3) {
                                    history.push('/Home/accounts');
                                }
                                if (assignOwner === field3) {
                                    GetAll()
                                }
                            }
                        }
                        else {
                            const allUpdatedSuccessfully = response.data.every(item =>
                                item.message === "Account Has Updated Successfully"
                            );
                            if (allUpdatedSuccessfully) {
                                loadingRef.current = false;
                                setDelteClick(false)
                                dispatch(setEditCall(false))
                                if (pageType === "Listing") {
                                    setStates({
                                        selectedRows: [],
                                        selectedRowKeys: [],
                                    })
                                }
                                message.success("Data updated for selected records")
                                GetAll()
                                setUpdatePopup(false);
                                return;
                            }
                            loadingRef.current = false;
                            setDelteClick(false)
                            dispatch(setEditCall(false))
                            setErrorData(response.data);
                            setIsModalVisible1(true);
                        }
                    }
                } catch (error) {
                    message.error(error);
                    loadingRef.current = false;
                    setDelteClick(false)
                }
            } else {
                loadingRef.current = false;
                setDelteClick(false)
                message.error("Field is Empty");
            }
        }
        if (popupType === "Bulk Update") {
            const validation = RequiredValidity(selectBoxes);
            if (!validation.isValid) {
                message.error(validation.message);
                loadingRef.current = false;
                setDelteClick(false)
                return;
            }
            const flatFields = await selectBoxes.reduce(async (accPromise, item) => {
                const acc = await accPromise;
                const { editedField, editedValue, visible, Key } = item;
                if (!editedField) return acc;
                let value = null;
                switch (Key) {
                    case 'FileUpload':
                        value = normalizeValue(editedValue ?? null);
                        break;
                    case 'MultiFileUpload':
                        value = editedValue || [];
                        break;
                    case 'Date':
                        value = editedValue;
                        // value = editedValue ? moment(editedValue).format("YYYY-MM-DD") : null;
                        break;
                    case 'Number':
                    case 'Percentage':
                        value = editedValue !== undefined && editedValue !== "" ? Number(editedValue) : null;
                        break;
                    case 'Currency':
                        value = editedValue
                            ? await convertCurrency(ConvertRate, Number(editedValue))
                            : null;
                        break;
                    case 'Multi-Dropdown':
                        value = editedValue && editedValue.length > 0 ? editedValue.join(",") : null;
                        break;
                    case 'CheckBox':
                        value = editedValue ?? false;
                        break;
                    default:
                        value = normalizeValue(editedValue ?? null);
                        break;
                }
                if (visible === "No") {
                    acc[editedField] = normalizeValue(value);
                    return acc;
                }
                if (editedValue != null) {
                    acc[editedField] = normalizeValue(value);
                }
                return acc;
            }, {});
            const finalPayload = Object.entries(flatFields).reduce((acc, [key, value]) => {
                const fieldInfo = editAttributes.find(f => f.fieldKey === key);
                if (!fieldInfo) return acc;
                if (fieldInfo.customFieldType === "Default") {
                    acc[key] = value;
                } else {
                    if (!acc.customFieldValues) acc.customFieldValues = [];
                    acc.customFieldValues.push({
                        entityId: fieldInfo.entityId,
                        fieldId: fieldInfo.fieldId,
                        value
                    });
                }
                return acc;
            }, {});
            Object.assign(formData, finalPayload);
            try {
                const response = await massUpdateAccount(formData)
                if (response.status === 200) {
                    const allUpdatedSuccessfully = response.data.every(item =>
                        item.message === "Account Has Updated Successfully"
                    );
                    if (allUpdatedSuccessfully) {
                        dispatch(setEditCall(false))
                        if (pageType === "Listing") {
                            setStates({
                                selectedRows: [],
                                selectedRowKeys: [],
                            })
                        }
                        message.success("Data updated for selected records")
                        GetAll()
                        setUpdatePopup(false);
                        loadingRef.current = false;
                        setDelteClick(false)
                        return;
                    }
                    loadingRef.current = false;
                    setDelteClick(false)
                    dispatch(setEditCall(false))
                    setErrorData(response.data);
                    setIsModalVisible1(true);
                }
            } catch (error) {
                message.error(error);
                loadingRef.current = false;
                setDelteClick(false)
            }
        }
    }
    const HandleIsModalVisible = (value) => {
        setUpdatePopup(value)
        setIsModalVisible(value)
    }
    async function onDelete() {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        const payload = {
            accountIds: accountIDs
        }
        try {
            const response = await massDeleteAccount(payload);
            if (response.status === 200) {
                if (popupType === "Delete") {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible(true);
                        dispatch(setEditCall(false))
                        loadingRef.current = false;
                        setDelteClick(false)
                    } else {
                        const isAutomation = response.data[0].entityMessage === AutomationMessage;
                        const isApproval = response.data[0].entityMessage === ApprovalMessage;
                        dispatch(setEditCall(false))
                        loadingRef.current = false;
                        setDelteClick(false)
                        if (isApproval) {
                            successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                        } else if (isAutomation) {
                            successMessage("Automation rule triggered", response.data[0].entityMessage);
                        } else {
                            message.success(
                                <span>
                                    Account <strong>{response?.data?.[0]?.entityName}</strong> has been deleted successfully
                                </span>
                            );
                        }
                        history.push('/Home/accounts')
                        setUpdatePopup(false);
                    }
                } else {
                    const allUpdatedSuccessfully = response.data.every(item =>
                        item.entityMessage === "Account Has Deleted Successfully"
                    );
                    if (allUpdatedSuccessfully) {
                        dispatch(setEditCall(false))
                        message.success(`${accountIDs.length} records deleted successful`);
                        GetAll();
                        setStates({
                            selectedRows: [],
                            selectedRowKeys: [],
                        })
                        setUpdatePopup(false);
                        loadingRef.current = false;
                        setDelteClick(false)
                        return;
                    }
                    loadingRef.current = false;
                    setDelteClick(false)
                    dispatch(setEditCall(false))
                    setErrorData(response.data);
                    setIsModalVisible(true);
                }
            }
        }
        catch (error) {
            loadingRef.current = false;
            setDelteClick(false)
            message.error(error)
        }
    }
    const getRefreshtheTable = () => {
        setUpdatePopup(false);
        if (popupType === "Bulk Delete") {
            GetAll();
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        } if (popupType === "Delete") {
            history.push('/Home/accounts')
        }
    }
    const fetchCustomGroupsAndFields = async () => {
        try {
            const allFieldsRaw = await getAllCustomFieldByCompanyAndEntity(ENTITY_ID);
            const allFields = [...allFieldsRaw].sort((a, b) => {
                if (a.fieldGroupSortOrder !== b.fieldGroupSortOrder) {
                    return a.fieldGroupSortOrder - b.fieldGroupSortOrder;
                }
                return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
            });
            const removeFields = ["accountName", "accountNumber"];
            const removeFieldsTypes = ["FileUpload", "MultiFileUpload"];
            const filteredAttributes = allFields.filter(
                item => !removeFields.includes(item.fieldKey) && !removeFieldsTypes.includes(item.fieldType)
            );
            const structure = filteredAttributes.filter((item) => item.fieldVisible === 'Yes').map((field) => ({
                fieldId: field.fieldId,
                entityId: field.entityId,
                customFieldValueId: null,
                fieldKey: field.fieldKey,
                fieldType: field.fieldType,
                fieldLabel: field.fieldLabel,
                dropdownId: field.dropdownId,
                dropdownType: field.dropdownType,
                customFieldType: field.customFieldType,
            }));
            setEditAttributes(structure);
            if (structure.length > 0) {
                const firstField = structure[0];
                setSelectBoxes([{
                    editedField: structure[0].fieldKey,
                    editedValue: structure[0].fieldType === "CheckBox" ? false : null,
                    Key: structure[0].fieldType
                }]);
                const isCustomDropdown =
                    (firstField.fieldType === 'Dropdown' || firstField?.fieldType === 'Multi-Dropdown') &&
                    firstField.dropdownId &&
                    !DEFAULT_DROPDOWN_FIELDS.includes(firstField.fieldKey);

                if (isCustomDropdown) {
                    setDropdownLoading(prev => ({ ...prev, [firstField.fieldKey]: true }));
                    try {
                        const res = await findAllCustomOptionsByDropdown(firstField.dropdownId);
                        setDropdownOptions(prev => ({ ...prev, [firstField.fieldKey]: res }));
                    } catch (err) {
                        setDropdownOptions(prev => ({ ...prev, [firstField.fieldKey]: [] }));
                    } finally {
                        setDropdownLoading(prev => ({ ...prev, [firstField.fieldKey]: false }));
                    }
                }
            } else {
                setSelectBoxes([]);
            }
        } catch {
            message.error("Failed to load custom fields");
        }
    };
    const handleViewChange = async (index, fieldName, value, key, option) => {
        let updatedFormData = [...selectBoxes];
        if (fieldName === "editedField") {
            const oldData = updatedFormData[index].editedField;
            if (oldData === "accountType") {
                updatedFormData = updatedFormData.filter((item, idx) => {
                    if (idx === 0) return true;
                    return !["customerStatus", "industry", "accountOwner", "parentOrganization", "rating"].includes(item.editedField);
                });
            }
            updatedFormData[index] = {
                ...updatedFormData[index],
                editedField: value,
                editedValue: key === "CheckBox" ? false : null,
                Key: key,
            };
            const selectedAttribute = editAttributes.find(attr => attr.fieldKey === value);
            const isCustomDropdown =
                (selectedAttribute?.fieldType === 'Dropdown' || selectedAttribute?.fieldType === 'Multi-Dropdown') &&
                selectedAttribute?.dropdownId &&
                !DEFAULT_DROPDOWN_FIELDS.includes(value);
            if (isCustomDropdown) {
                setDropdownLoading(prev => ({ ...prev, [selectedAttribute.fieldKey]: true }));
                try {
                    const res = await findAllCustomOptionsByDropdown(selectedAttribute.dropdownId);
                    setDropdownOptions(prev => ({ ...prev, [selectedAttribute.fieldKey]: res }));
                } catch (err) {
                    setDropdownOptions(prev => ({ ...prev, [selectedAttribute.fieldKey]: [] }));
                } finally {
                    setDropdownLoading(prev => ({ ...prev, [selectedAttribute.fieldKey]: false }));
                }
            }
            if (value === "country" || value === "state" || value === "city" || value === "customerStatus" || value === "accountType" || value === "street" || value === "postcode") {
                const countryField = {
                    editedField: "country",
                    editedValue: null,
                    Key: null,

                };
                const stateField = {
                    editedField: "state",
                    editedValue: null,
                    Key: null,

                };
                const cityField = {
                    editedField: "city",
                    editedValue: null,
                    Key: null,

                };
                const streetField = {
                    editedField: "street",
                    editedValue: null,
                    Key: null,

                };
                if (value === "country") {
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "accountType" && item.editedField !== "customerStatus"
                    );
                    updatedFormData = updatedFormData.map(item =>
                        (item.editedField === "state" || item.editedField === "city" || item.editedField === "street" || item.editedField === "postcode")
                            ? {
                                ...item, editedField: item.editedField, editedValue: null
                            }
                            : item
                    );
                    setStateData([])
                    setCityData([])
                }
                if (value === "state") {
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== 'city' && item.editedField !== "street" && item.editedField !== "postcode" && item.editedField !== "accountType" && item.editedField !== "customerStatus"
                    );
                    updatedFormData.splice(index, 0, countryField);

                    setStateData([])
                    setCityData([])
                }
                if (value === "city") {
                    setStateData([])
                    setCityData([])
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "street" && item.editedField !== "postcode" && item.editedField !== "accountType" && item.editedField !== "customerStatus"
                    );
                    updatedFormData.splice(index, 0, countryField, stateField);
                }
                if (value === "street") {
                    setStateData([])
                    setCityData([])
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "postcode" && item.editedField !== "accountType" && item.editedField !== "customerStatus"
                    );
                    updatedFormData.splice(index, 0, countryField, stateField, cityField);
                }
                if (value === "postcode") {
                    setStateData([])
                    setCityData([])
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "street" && item.editedField !== "accountType" && item.editedField !== "customerStatus"
                    );
                    updatedFormData.splice(index, 0, countryField, stateField, cityField, streetField);
                }
                if (value === "accountType") {
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "street" && item.editedField !== "postcode"
                    );
                    updatedFormData = updatedFormData.map(item =>
                        (item.editedField === "customerStatus")
                            ? {
                                ...item, editedField: item.editedField, editedValue: null
                            }
                            : item
                    );
                }
                if (value === "customerStatus") {
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "street" && item.editedField !== "postcode"
                    );
                    const hasCountry = updatedFormData.some(item => item.editedField === "accountType");
                    const inserts = [];
                    if (!hasCountry) {
                        inserts.push({
                            editedField: "accountType",
                            editedValue: null,
                            Key: null,

                        });
                    }
                    if (inserts.length > 0) {
                        updatedFormData.splice(index, 0, ...inserts);
                        index += inserts.length;
                    }
                }
                // if (value === "accountOwner") {
                //     const hasCountry = updatedFormData.some(item => item.editedField === "accountOwner");
                //     const inserts = [];
                //     if (!hasCountry) {
                //         inserts.push({
                //             editedField: "accountType",
                //             editedValue: null,
                //             Key: null,
                //             
                //         });
                //     }
                //     if (inserts.length > 0) {
                //         updatedFormData.splice(index, 0, ...inserts);
                //         index += inserts.length;
                //     }
                // }
            } else {
                updatedFormData = updatedFormData.filter(
                    item => !["country", "state", "city", "street", "postcode", "accountType", "customerStatus"].includes(item.editedField)
                );
            }
        }
        else {
            const editedFieldType = updatedFormData[index]?.editedField;
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: value,
                Key: key
            };
            if (editedFieldType === "country") {
                try {
                    const response = await getStateData(option.key)
                    setStateData(response)
                    setCityData([])
                    const existingIndex = updatedFormData.find(
                        item => item.editedField === "state"
                    );
                    const existingIndex2 = updatedFormData.find(
                        item => item.editedField === "city"
                    );
                    const existingIndex3 = updatedFormData.find(
                        item => item.editedField === "street"
                    );
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "state") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "state",
                            editedValue: null,
                            Key: null,

                            visible: "No"
                        });
                    }
                    if (existingIndex2) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "city") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "city",
                            editedValue: null,
                            Key: null,

                            visible: "No"
                        });
                    }
                    if (existingIndex3) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "street") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "street",
                            editedValue: null,
                            Key: null,

                            visible: "No"
                        });
                    }
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,

                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "state" || item.editedField === "city" || item.editedField === "street" || item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    setCityData([])
                    setStateData([])
                    message.error(error)
                }
            }
            else if (editedFieldType === "state") {
                try {
                    const response = await getCityData(option.key)
                    setCityData(response)
                    const existingIndex2 = updatedFormData.find(
                        item => item.editedField === "city"
                    );
                    const existingIndex3 = updatedFormData.find(
                        item => item.editedField === "street"
                    );
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex2) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "city") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "city",
                            editedValue: null,
                            Key: null,

                            visible: "No"
                        });
                    }
                    if (existingIndex3) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "street") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "street",
                            editedValue: null,
                            Key: null,

                            visible: "No"
                        });
                    }
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,

                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "city" || item.editedField === "street" || item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    setCityData([])
                    message.error(error)
                }
            }
            else if (editedFieldType === "city") {
                try {
                    const existingIndex3 = updatedFormData.find(
                        item => item.editedField === "street"
                    );
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex3) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "street") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "street",
                            editedValue: null,
                            Key: null,

                            visible: "No"
                        });
                    }
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,

                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "street" || item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    message.error(error)
                }
            }
            else if (editedFieldType === "street") {
                try {
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,

                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    message.error(error)
                }
            }
            else if (editedFieldType === "accountType") {
                if (option.children === "Customer") {
                    const existingIndex = updatedFormData.find(
                        item => item.editedField === "customerStatus"
                    );
                    if (existingIndex) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "customerStatus") {
                                return {
                                    ...item,
                                    editedValue: "Prospective Customer",
                                };
                            }
                            return item;
                        });
                    } else {
                        updatedFormData.push({
                            editedField: "customerStatus",
                            editedValue: "Prospective Customer",
                            Key: null,

                            visible: "No"
                        });
                    }
                }

                else if (option.children === "Competitor") {
                    const competitorFields = [
                        { field: "industry", value: 23 },
                        { field: "customerStatus", value: null },
                        { field: "accountOwner", value: null },
                        { field: "parentOrganization", value: null },
                        { field: "rating", value: null }
                    ];

                    competitorFields.forEach(({ field, value }) => {
                        const existingIndex = updatedFormData.find(
                            item => item.editedField === field
                        );

                        if (existingIndex) {
                            updatedFormData = updatedFormData.filter(item => item.editedField !== field);
                            updatedFormData.push({
                                editedField: field,
                                editedValue: value,
                                Key: null,

                                visible: "No"
                            });
                        } else {
                            updatedFormData.push({
                                editedField: field,
                                editedValue: value,
                                Key: null,

                                visible: "No"
                            });
                        }
                    });
                }

                else {
                    const extraFields = ["industry", "customerStatus", "accountOwner", "parentOrganization", "rating"];
                    extraFields.forEach(field => {
                        const existingIndex = updatedFormData.find(
                            item => item.editedField === field
                        );

                        if (existingIndex) {
                            updatedFormData = updatedFormData.filter(item => item.editedField !== field);
                            updatedFormData.push({
                                editedField: field,
                                editedValue: null,
                                Key: null,

                                visible: "No"
                            });
                        } else {
                            updatedFormData.push({
                                editedField: field,
                                editedValue: null,
                                Key: null,

                                visible: "No"
                            });
                        }
                    });
                }
            }
        }
        setSelectBoxes(updatedFormData);
    };
    const FIELDTYPE_VALIDATOR_MAP = {
        String: (value) => nameOnChangeValidator(value, 20),
        Number: (value) => validateNumberField(value),
        Currency: (value, currencySettings) => validateCurrencyField(value, currencySettings?.decimalOfCurrency ?? 2),
        Percentage: (value, currencySettings) => validatePercentageField(value, currencySettings?.decimalOfCurrency ?? 2),
        LongString: (value) => validateDescriptionField(value, 2500)
    };
    const FIELD_VALIDATOR_MAP = {
        website: (value) => validateUrlField(value, 2000),
        street: (value) => nameOnChangeValidator(value, 100),
        postcode: (value) => validateZipCode(value, 25),
    };
    const handleValidatedChange = (index, fieldName, value, key, fieldKey, option) => {
        let error = null;
        if (FIELD_VALIDATOR_MAP[fieldKey]) {
            error = FIELD_VALIDATOR_MAP[fieldKey](value, defaultCurrency);
        } else if (FIELDTYPE_VALIDATOR_MAP[fieldKey]) {
            error = FIELDTYPE_VALIDATOR_MAP[fieldKey](value, defaultCurrency);
        }
        if (error) {
            message.error(error);
            return;
        }
        handleViewChange(index, fieldName, value, key, option);
    };
    const getAvailableOptions = (currentIndex) => {
        const selectedValues = selectBoxes.filter(box => box.visible !== "No").map(box => box.editedField).filter(value => value !== undefined);
        return editAttributes.filter(option => !selectedValues.includes(option.filedValue) || selectBoxes[currentIndex].editedField === option.filedValue);
    };
    function getFieldTypeByValue(fieldValue) {
        const field = editAttributes.find(item => item.filedValue === fieldValue);
        return field ? field.FieldType : null;
    }
    const handleLeadOwner = (value) => {
        setField3(value)
    }
    const getUserDetail = async () => {
        if (action === "SingleChangeOwner") {
            setField3(assignOwner)
            form.setFieldsValue({
                accountowner: assignOwner
            });
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if (profile.department === "Sales") {
                setField3(profile.userId)
                form.setFieldsValue({
                    accountowner: profile.userId
                });
            }
        }
        setCompanyId(profile.companyId)
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            UserDetailsApi(),
            AccountApi(),
            fetchCustomGroupsAndFields(),
            getCountry(),
            getUserDetail()
        ])
        setUiReady(true)
    };
    const fetchAll1 = async () => {
        await Promise.allSettled([
            UserDetailsApi(),
            getUserDetail(),
            fetchCustomGroupsAndFields()
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (updatePopup) {
            if (popupType === "Bulk Update") {
                fetchAll()
            }
            else if (popupType === "Change Owner") {
                fetchAll1()
            }
            else {
                setUiReady(true)
            }
        }
    }, [updatePopup])
    const leadOwnerField = editAttributes.find(
        (item) => item.fieldKey === "accountOwner"
    );
    return (
        <>
            <Modal
                title={popupType}
                open={updatePopup}
                onCancel={handleClose}
                // centered
                maskClosable={false}
                footer={uiReady ? [
                    <div>
                        {popupType === "Bulk Update" &&
                            <>
                                <Button onClick={handleClose} className="gray-button" size="small">
                                    <CancelIcon />Cancel
                                </Button>
                                <Button className='btn-add_new button_colors' onClick={onSubmit} size="small" loading={deleteClick} disabled={deleteClick} >
                                    {!deleteClick && <SaveIcon />}Update
                                </Button>
                            </>
                        }
                        {popupType === "Change Owner" &&
                            <>
                                <Button onClick={handleClose} className="gray-button" size="small" >
                                    <CancelIcon />Cancel
                                </Button>
                                <Button htmlType="submit" size="small" className='btn-add_new button_colors' onClick={onSubmit} loading={deleteClick} disabled={deleteClick} >
                                    {!deleteClick && <ChangeOwnerIcon />}Change Owner
                                </Button>
                            </>
                        }

                        {popupType.includes("Delete") &&
                            <>
                                <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                                    <CancelIcon /> Cancel
                                </Button>
                                <Button htmlType="submit" size="small" onClick={onDelete} className='red-button' loading={deleteClick} disabled={deleteClick} >
                                    {!deleteClick && <DeleteIcon />}{popupType}
                                </Button>
                            </>}
                    </div>
                ] : false}
            // width={600}
            >
                {uiReady ? <>
                    {popupType === "Bulk Update" &&
                        (editAttributes.length > 0 ?
                            <AddUser>
                                <div className="user-info-form">
                                    <BasicFormWrapper>
                                        <Form style={{ width: '100%' }} form={form} name="AccountMassUpdate" colon={false} >
                                            {selectBoxes.filter((item) => item?.visible !== "No").map((selectbox, index) => {
                                                const filedType = getFieldTypeByValue(selectbox.editedField)
                                                const accountTypeValue = selectBoxes[0]?.editedValue;
                                                return (
                                                    <Row gutter={30} style={{ marginBottom: 20, marginTop: 20, padding: "0px 20px" }}>
                                                        <Col span={10}>
                                                            <Form.Item >
                                                                <Select style={{ width: '100%' }}
                                                                    placeholder="Select Field"
                                                                    showSearch
                                                                    optionFilterProp="children"
                                                                    filterOption={(input, option) =>
                                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                    }
                                                                    value={selectbox.editedField}
                                                                    onChange={(record, option) => {
                                                                        const Key = option.FieldType
                                                                        handleViewChange(index, 'editedField', record, Key);
                                                                    }}
                                                                    disabled={index !== 0}
                                                                >
                                                                    {getAvailableOptions(index).map((option, idx) => (
                                                                        <Option value={option.fieldKey} key={idx} FieldType={option.fieldType}>
                                                                            {option.fieldLabel}
                                                                        </Option>
                                                                    ))}
                                                                </Select>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={14} style={filedType === 'CheckBox' ? { display: 'flex', alignItems: 'center', justifyContent: 'flex-start' } : {}}>
                                                            <Form.Item key={index}>
                                                                {filedType === 'Drop Down' ?
                                                                    (DEFAULT_DROPDOWN_FIELDS.includes(selectbox.editedField) ? (
                                                                        <Select placeholder="Select Value"
                                                                            showSearch
                                                                            style={{ width: "100%" }}
                                                                            optionFilterProp="children"
                                                                            {...(selectbox.editedField === "accountOwner" || selectbox.editedField === "parentOrganization"
                                                                                ? { optionLabelProp: "label" } : {})}
                                                                            filterOption={(input, option) =>
                                                                                (selectbox.editedField === "accountOwner" || selectbox.editedField === "parentOrganization")
                                                                                    ? (() => {
                                                                                        const usernameElement = option.children.props.children[1].props.children[0];
                                                                                        if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                            const username = String(usernameElement.props.children);
                                                                                            return username.toLowerCase().includes(input.toLowerCase());
                                                                                        }
                                                                                        return false;
                                                                                    })()
                                                                                    : option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                            }
                                                                            disabled={index === 1 &&
                                                                                selectbox.editedField === "customerStatus" &&
                                                                                accountTypeValue !== 1}
                                                                            name="editedValue"
                                                                            value={selectbox.editedValue}
                                                                            onChange={(value, option) => {
                                                                                handleViewChange(index, 'editedValue', value, filedType, option);
                                                                            }}
                                                                        >
                                                                            {(selectbox.editedField === "accountOwner") &&
                                                                                users.filter(item => item.department === "Sales").map((option, i) => (
                                                                                    <Option value={option.userId}
                                                                                        label={(
                                                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                                <div className='Div_flex2'>
                                                                                                    <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                                        {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                                            < img src={option.profilePic} alt="profile" />
                                                                                                            :
                                                                                                            <span className="image_icon UserIcon">
                                                                                                                {option.firstName.slice(0, 1).toUpperCase()}
                                                                                                            </span>
                                                                                                        }
                                                                                                        <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                        key={i}>
                                                                                        <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                                            <div>
                                                                                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                                    < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                                    :
                                                                                                    <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                        {option.firstName.slice(0, 1).toUpperCase()}
                                                                                                    </span>
                                                                                                }</div>
                                                                                            <div>
                                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                                                <p style={{ margin: 0 }}>{option.username}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Option>))
                                                                            }
                                                                            {selectbox.editedField === "parentOrganization" &&
                                                                                <>
                                                                                    {accountData}
                                                                                </>}
                                                                            {selectbox.editedField === "country" &&
                                                                                <>
                                                                                    {allCountry}
                                                                                </>}
                                                                            {selectbox.editedField === "state" &&
                                                                                <>
                                                                                    {stateData?.map((option) => (
                                                                                        <Option key={option.stateId} value={option.state}>
                                                                                            {option.state}
                                                                                        </Option>
                                                                                    ))}
                                                                                </>}
                                                                            {selectbox.editedField === "city" &&
                                                                                <>
                                                                                    {cityData?.map((option) => (
                                                                                        <Option key={option.cityId} value={option.city}>
                                                                                            {option.city}
                                                                                        </Option>
                                                                                    ))}
                                                                                </>}
                                                                        </Select>
                                                                    ) : (
                                                                        !dropdownLoading[selectbox.editedField] ?
                                                                            <Select
                                                                                placeholder="Select Value"
                                                                                showSearch
                                                                                style={{ width: "100%" }}
                                                                                optionFilterProp="children"
                                                                                value={selectbox.editedValue}
                                                                                onChange={(value, option) => {
                                                                                    handleViewChange(index, 'editedValue', value, filedType, option);
                                                                                }}
                                                                                filterOption={(input, option) =>
                                                                                    option.children.toLowerCase().includes(input.toLowerCase())
                                                                                }
                                                                            >
                                                                                {(dropdownOptions[selectbox.editedField] || []).map((opt, i) => (
                                                                                    <Option key={i} value={opt.customDropdownOptionId}>
                                                                                        {opt.option}
                                                                                    </Option>
                                                                                ))}
                                                                            </Select> :
                                                                            <div>
                                                                                <Skeleton.Input style={{ width: "100%" }} active />
                                                                            </div>
                                                                    )) :
                                                                    filedType === 'Multi-Dropdown' ?
                                                                        (!dropdownLoading[selectbox.editedField] ? <Select
                                                                            mode="multiple"
                                                                            className="MultiUiNew"
                                                                            style={{ width: '100%' }}
                                                                            placeholder="Select Value"
                                                                            showSearch value={selectbox.editedValue}
                                                                            optionFilterProp="children"
                                                                            filterOption={(input, opt) =>
                                                                                opt.children.toLowerCase().includes(input.toLowerCase())
                                                                            }
                                                                            onChange={(value, option) => {
                                                                                handleViewChange(index, 'editedValue', value, filedType, option);
                                                                            }}
                                                                        >
                                                                            {(dropdownOptions[selectbox.editedField] || []).map((opt, i) => (
                                                                                <Option key={i} value={opt.customDropdownOptionId}>
                                                                                    {opt.option}
                                                                                </Option>
                                                                            ))}
                                                                        </Select> :
                                                                            <div>
                                                                                <Skeleton.Input style={{ width: "100%" }} active />
                                                                            </div>) :
                                                                        filedType === 'CheckBox' ? <>
                                                                            <Checkbox checked={selectbox.editedValue} onChange={(e) => handleValidatedChange(index, 'editedValue', e.target.checked, filedType, selectbox.editedField)} />
                                                                            <span style={{ marginLeft: 5 }}>{selectbox.editedValue ? "Yes" : "No"}</span></>
                                                                            :
                                                                            filedType === 'String' ? (
                                                                                (<Input placeholder="Enter Value" style={{ width: "100%" }}
                                                                                    name="editedValue" maxLength={50}
                                                                                    value={selectbox.editedValue}
                                                                                    onChange={(e) => {
                                                                                        handleValidatedChange(index, 'editedValue', e.target.value, filedType, selectbox.editedField);
                                                                                    }} />
                                                                                ))
                                                                                : filedType === 'Number' ? (
                                                                                    (<Input placeholder="Enter Value" style={{ width: "100%" }}
                                                                                        name="editedValue" maxLength={25}
                                                                                        value={selectbox.editedValue}
                                                                                        onChange={(e) => {
                                                                                            handleValidatedChange(index, 'editedValue', e.target.value, filedType, selectbox.editedField);
                                                                                        }} />
                                                                                    ))
                                                                                    : filedType === 'Currency' ? (
                                                                                        (<Input placeholder="Enter Value" style={{ width: "100%" }}
                                                                                            name="editedValue"
                                                                                            value={selectbox.editedValue}
                                                                                            prefix={defaultCurrency?.symbol || '$'}
                                                                                            onChange={(e) => {
                                                                                                handleValidatedChange(index, 'editedValue', e.target.value, filedType, selectbox.editedField);
                                                                                            }} />
                                                                                        ))
                                                                                        : filedType === 'Percentage' ? (
                                                                                            (<Input placeholder="Enter Value" style={{ width: "100%" }}
                                                                                                name="editedValue"
                                                                                                value={selectbox.editedValue} prefix="%" min={0} max={100}
                                                                                                onChange={(e) => {
                                                                                                    handleValidatedChange(index, 'editedValue', e.target.value, filedType, selectbox.editedField);
                                                                                                }} />
                                                                                            ))
                                                                                            : filedType === 'Date' ? (
                                                                                                (<DatePicker
                                                                                                    allowClear={false}
                                                                                                    format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                                                    placeholder="Enter Value" style={{ width: "100%" }}
                                                                                                    name="editedValue"
                                                                                                    value={selectbox.editedValue ? moment(selectbox.editedValue, "YYYY-MM-DD") : null}
                                                                                                    onChange={(date) => {
                                                                                                        handleValidatedChange(index, 'editedValue', date ? date.format("YYYY-MM-DD") : null, filedType, selectbox.editedField);
                                                                                                    }} />
                                                                                                ))
                                                                                                : filedType === 'LongString' ? (
                                                                                                    (<Input.TextArea placeholder="Enter Value" style={{ width: "100%" }}
                                                                                                        rows={3} maxLength={2500}
                                                                                                        showCount
                                                                                                        name="editedValue"
                                                                                                        value={selectbox.editedValue}
                                                                                                        onChange={(e) => {
                                                                                                            handleValidatedChange(index, 'editedValue', e.target.value, filedType, selectbox.editedField);
                                                                                                        }} />
                                                                                                    ))
                                                                                                    : ""
                                                                }
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                )
                                            })}
                                        </Form>
                                    </BasicFormWrapper>
                                </div>
                            </AddUser> :
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "120px" }}>
                                <Spin />
                            </div>)
                    }
                    {popupType === "Change Owner" &&
                        (editAttributes.length ?
                            <AddUser>
                                <div className="user-info-form">
                                    <BasicFormWrapper>
                                        <Form style={{ width: '100%' }} form={form} name="Assignto" colon={false}>
                                            <Row gutter={30} style={{ marginBottom: 20, marginTop: 20, padding: "0px 20px" }}>
                                                <Col span={10}>
                                                    <Form.Item>
                                                        <Select style={{ width: '100%' }}
                                                            placeholder="Select Field"
                                                            showSearch
                                                            disabled
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) =>
                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                            value={leadOwnerField?.fieldId}
                                                        >
                                                            {editAttributes?.map((option, key) => (
                                                                <Option key={key} value={option.fieldId}>
                                                                    {option.fieldLabel}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={14}>
                                                    {leadOwnerField?.fieldKey === "accountOwner" &&
                                                        <Form.Item name="accountowner" id="accountowner" >
                                                            <Select style={{ width: '100%' }}
                                                                placeholder="Select Account Owner"
                                                                showSearch optionLabelProp="label"
                                                                filterOption={(input, option) => {
                                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                        const username = String(usernameElement.props.children);
                                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                                    }
                                                                    return false;
                                                                }
                                                                }
                                                                onChange={handleLeadOwner}>
                                                                {users.filter(item => item.department === "Sales").map((option, i) => (
                                                                    <Option value={option.userId}
                                                                        label={(
                                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                <div className='Div_flex2'>
                                                                                    <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                        {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                            < img src={option.profilePic} alt="profile" />
                                                                                            :
                                                                                            <span className="image_icon UserIcon">
                                                                                                {option.firstName.slice(0, 1).toUpperCase()}
                                                                                            </span>
                                                                                        }
                                                                                        <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        key={i}>
                                                                        <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                            <div>
                                                                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                    < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                    :
                                                                                    <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                        {option.firstName.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                }</div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                                <p style={{ margin: 0 }}>{option.username}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}
                                                            </Select>
                                                        </Form.Item>}
                                                </Col>
                                            </Row>
                                        </Form>
                                    </BasicFormWrapper>
                                </div>
                            </AddUser> :
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100px" }}>
                                <Empty />
                            </div>)
                    }
                    {popupType.includes("Delete") &&
                        < div >
                            <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                {popupType === "Bulk Delete" && <p>Are you sure you want to delete the selected accounts?</p>}
                                {popupType === "Delete" && <p>Are you sure you want to delete?</p>}
                            </div>
                        </div>
                    }
                </> :
                    <div className="spin" style={{ height: "150px" }}>
                        <Spin />
                    </div>}
            </Modal >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page={pageType === "Listing" ? "DetailsError" : "Details"} type="Account" getCallBack={getRefreshtheTable} />}
            {isModalVisible && <DeleteConnectionPopup confirmPopup={isModalVisible} setConfirmPopup={HandleIsModalVisible} Respone={errorData} page={popupType === "Bulk Delete" ? "DetailsError" : "Details"} type="Account" getCallBack={getRefreshtheTable} />}
        </>
    );
};

Popup.propTypes = {
    successMessage: PropTypes.func.isRequired,
    updatePopup: PropTypes.bool.isRequired,
    setUpdatePopup: PropTypes.func.isRequired,
    accountIDs: PropTypes.array.isRequired,
    GetAll: PropTypes.func.isRequired,
    setStates: PropTypes.func.isRequired,
    popupType: PropTypes.string.isRequired,
    pageType: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    assignOwner: PropTypes.number.isRequired,
};

export default Popup;
